import React, { useState, useRef } from "react";
import domtoimage from "dom-to-image";
import styles from "./PlacaDiseno2.module.css";
import nuevoLogo from "../../../Assets/nuevoLogo.png";
import { BsTextareaResize } from "react-icons/bs";
import { FaHome, FaBed, FaShower, FaCar, FaFaucet } from "react-icons/fa";

const AVAILABLE_FEATURES = [
  { key: "terreno", label: "m² terreno", icon: BsTextareaResize, defaultValue: "380 m²\nterreno" },
  { key: "cubiertos", label: "m² cubiertos", icon: FaHome, defaultValue: "190 m²\ncubiertos" },
  { key: "habitaciones", label: "Habitaciones", icon: FaBed, defaultValue: "3 hab." },
  { key: "banos", label: "Baños", icon: FaShower, defaultValue: "2 baños" },
  { key: "cochera", label: "Cochera", icon: FaCar, defaultValue: "Doble\ncochera" },
  { key: "servicios", label: "Servicios", icon: FaFaucet, defaultValue: "Todos los\nservicios" },
];

const PlacaDiseno2 = () => {
  const [image, setImage] = useState(null);
  const [saleType, setSaleType] = useState("EN VENTA");
  const [propertyType, setPropertyType] = useState("Casa");
  const [location, setLocation] = useState("Rodeo de la Cruz, Guaymallén");
  const [price, setPrice] = useState("USD 90.000");
  const [agent, setAgent] = useState("JULIETA GARCÍA CCPIM 2009");
  const [features, setFeatures] = useState(
    AVAILABLE_FEATURES.reduce((acc, f) => {
      acc[f.key] = { enabled: true, value: f.defaultValue };
      return acc;
    }, {})
  );

  const placaRef = useRef(null);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => setImage(event.target.result);
      reader.readAsDataURL(file);
    }
  };

  const toggleFeature = (key) => {
    setFeatures((prev) => ({
      ...prev,
      [key]: { ...prev[key], enabled: !prev[key].enabled },
    }));
  };

  const updateFeatureValue = (key, value) => {
    setFeatures((prev) => ({
      ...prev,
      [key]: { ...prev[key], value },
    }));
  };

  const downloadPlaca = () => {
    const element = placaRef.current;
    const originalStyle = element.getAttribute("style");

    element.setAttribute(
      "style",
      `width: 1080px; height: 1080px; transform: none; transform-origin: top left; position: relative;`
    );

    domtoimage
      .toPng(element)
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.download = "placa_diseno2.png";
        link.href = dataUrl;
        link.click();
      })
      .catch((error) => {
        console.error("Error al generar la imagen:", error);
      })
      .finally(() => {
        if (originalStyle) {
          element.setAttribute("style", originalStyle);
        } else {
          element.removeAttribute("style");
        }
      });
  };

  const enabledFeatures = AVAILABLE_FEATURES.filter(
    (f) => features[f.key]?.enabled
  );

  return (
    <div className={styles.container}>
      <div className={styles.editControls}>
        <label>
          Tipo de venta:
          <input
            type="text"
            value={saleType}
            onChange={(e) => setSaleType(e.target.value)}
            className={styles.input}
          />
        </label>
        <label>
          Tipo de propiedad:
          <input
            type="text"
            value={propertyType}
            onChange={(e) => setPropertyType(e.target.value)}
            className={styles.input}
          />
        </label>
        <label>
          Ubicación:
          <input
            type="text"
            value={location}
            onChange={(e) => setLocation(e.target.value)}
            className={styles.input}
          />
        </label>
        <label>
          Precio:
          <input
            type="text"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            className={styles.input}
          />
        </label>
        <label>
          Agente:
          <input
            type="text"
            value={agent}
            onChange={(e) => setAgent(e.target.value)}
            className={styles.input}
          />
        </label>
      </div>

      {/* Feature toggles */}
      <div className={styles.featureControls}>
        <strong>Iconos visibles:</strong>
        <div className={styles.featureToggles}>
          {AVAILABLE_FEATURES.map((f) => (
            <div key={f.key} className={styles.featureToggle}>
              <label>
                <input
                  type="checkbox"
                  checked={features[f.key]?.enabled || false}
                  onChange={() => toggleFeature(f.key)}
                />
                {f.label}
              </label>
              {features[f.key]?.enabled && (
                <textarea
                  value={features[f.key]?.value || ""}
                  onChange={(e) => updateFeatureValue(f.key, e.target.value)}
                  className={styles.featureInput}
                  rows={2}
                />
              )}
            </div>
          ))}
        </div>
      </div>

      <div ref={placaRef} className={styles.placa}>
        {/* Sale type badge top-left */}
        <div className={styles.saleBadge}>{saleType}</div>

        {/* Main image top half */}
        <div
          className={styles.mainImage}
          onClick={() => document.getElementById("fileInputMainD2").click()}
        >
          {image ? (
            <img src={image} alt="Principal" />
          ) : (
            <p className={styles.placeholderText}>
              Click para cargar imagen
            </p>
          )}
          <input
            type="file"
            id="fileInputMainD2"
            accept="image/*"
            onChange={handleImageChange}
            hidden
          />
        </div>

        {/* Purple bottom section */}
        <div className={styles.bottomSection}>
          {/* Price badge at transition */}
          <div className={styles.priceBadge}>
            <span className={styles.pricePrefix}>
              {price.split(" ")[0]}
            </span>{" "}
            <span className={styles.priceAmount}>
              {price.split(" ").slice(1).join(" ")}
            </span>
          </div>

          {/* Property info */}
          <div className={styles.propertyInfo}>
            <span>
              {propertyType} <strong>{saleType}</strong>
            </span>
            <br />
            <span>{location}</span>
          </div>

          {/* Features row */}
          {enabledFeatures.length > 0 && (
            <div className={styles.featuresRow}>
              {enabledFeatures.map((f) => {
                const IconComp = f.icon;
                return (
                  <div key={f.key} className={styles.featureItem}>
                    <IconComp className={styles.featureIcon} />
                    <span className={styles.featureLabel}>
                      {(features[f.key]?.value || "").split("\n").map((line, i, arr) => (
                        <span key={i}>
                          {line}
                          {i < arr.length - 1 && <br />}
                        </span>
                      ))}
                    </span>
                  </div>
                );
              })}
            </div>
          )}

          {/* Footer */}
          <div className={styles.footer}>
            <span className={styles.agentText}>{agent}</span>
            <div className={styles.logo}>
              <img src={nuevoLogo} alt="Logo By Raíces" />
            </div>
          </div>
        </div>
      </div>

      <button onClick={downloadPlaca} className={styles.downloadButton}>
        Descargar Placa
      </button>
    </div>
  );
};

export default PlacaDiseno2;
